import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { createDraft } from "../lib/draft.lib";

export function useInitDraft(orderId: string, shopId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  useEffect(() => {
    setDraft((current) => current ?? createDraft(orderId, shopId));
  }, [orderId, shopId, setDraft]);
}
